const ACCORDION_DETAIL_TITLES = {
  PAID: 'pago',
  REQUESTED: 'solicitado',
  RELEASED: 'liberado',
}
const ACCORDION_DETAIL_TITLES_RESUME = {
  PAID: 'do empréstimo pago',
  REQUESTED: 'da solicitação',
  RELEASED: 'do crédito aprovado',
}

export { ACCORDION_DETAIL_TITLES, ACCORDION_DETAIL_TITLES_RESUME }
